import { twMerge } from 'tailwind-merge';

interface ContentProps {
  className?: string;
  children: React.ReactNode;
}

export const Content = (props: ContentProps) => {
  const { className } = props;
  return (
    <div
      className={twMerge(
        'w-full max-w-[100rem] px-1.5 pt-4 lg:px-7 lg:pt-24 xl:px-[90px]',
        className
      )}
    >
      {props.children}
    </div>
  );
};
